/**
 * Formats a duration given in whole seconds as `m:ss` (e.g. 245 → "4:05").
 *
 * Minutes are never zero-padded; seconds always are. Durations of an hour or
 * more roll into the minutes field rather than wrapping (e.g. 3700 → "61:40"),
 * which is why this uses plain arithmetic instead of moment's `m:ss` token.
 * Null, undefined, negative, or non-finite input renders as "0:00".
 *
 * @param seconds - The duration in whole seconds.
 * @returns The duration formatted as `m:ss`.
 */
export function formatDuration(seconds?: number | null): string {
    if (seconds == null || !Number.isFinite(seconds) || seconds < 0) {
        return "0:00";
    }

    const totalSeconds = Math.floor(seconds);
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = totalSeconds % 60;

    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
}

/** Vue global-filter wrapper for {@link formatDuration}. */
export function formatDurationFilter(seconds?: number | null): string {
    return formatDuration(seconds);
}
